import React, { useState } from 'react'
import { EditOutlined } from '@ant-design/icons'
import type { ICellRendererParams } from '@ag-grid-community/core'

export function PlanBenefitClickableCellRenderer(params: ICellRendererParams) {
  const [hovered, setHovered] = useState(false)
  const display = params.valueFormatted ?? String(params.value ?? '-')
  const isApproved =
    (params.data as Record<string, unknown>)?.__overrideStatus === 'APPROVED'

  return (
    <div
      onMouseEnter={() => !isApproved && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        gap: 4,
        cursor: isApproved ? 'default' : undefined,
      }}
    >
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
        }}
      >
        {display}
      </span>
      {!isApproved && (
        <EditOutlined
          style={{
            fontSize: 11,
            color: '#0d9488',
            flexShrink: 0,
            opacity: hovered ? 0.7 : 0,
            transition: 'opacity 150ms ease',
          }}
        />
      )}
    </div>
  )
}
